import axios from "axios";

const client = axios.create({
  baseURL: process.env.VUE_APP_API_ENDPOINT,
  headers: {
    Accept: "application/json",
  },
});

export default client;
